module.exports = __webpack_public_path__ + "img/kzms.62d1c05f.png";